import { AnyAction } from "redux";
import { FindById, Update } from "../../../universities";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { UniversitiesAdapter } from "../../../../adapter/universities-adapter";

export const FETCH_UPDATE_UNIVERSITY_REQUEST = 'FETCH_UPDATE_UNIVERSITY_REQUEST';
export const FETCH_UPDATE_UNIVERSITY_SUCCESS = 'FETCH_UPDATE_UNIVERSITY_SUCCESS';
export const FETCH_UPDATE_UNIVERSITY_FAILURE = 'FETCH_UPDATE_UNIVERSITY_FAILURE';
export const SET_UPDATE_SEARCHER = 'SET_UPDATE_UNIVERSITY';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchUpdateUniversityRequest = () => {
    return {
        type: FETCH_UPDATE_UNIVERSITY_REQUEST,
    };
};

const fetchUpdateUniversitySuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_UPDATE_UNIVERSITY_SUCCESS,
        payload: data
    };
};

const fetchUpdateUniversityFailure = (error: any) => {
    return {
        type: FETCH_UPDATE_UNIVERSITY_FAILURE,
        payload: error,
    };
};

export const setUpdateSearcher = (data: any) => {
    return {
        type: SET_UPDATE_SEARCHER,
        payload: data,
    };
};

export const update = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateUniversityRequest());
        try {
            const response = await Update(id, data);
            dispatch(fetchUpdateUniversitySuccess(
                Adapter.from(response.data).to((value) => new UniversitiesAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchUpdateUniversityFailure(error.message));
        }
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateUniversityRequest());
        try {
            const response = await FindById(id , "fields=*.*.*");
            dispatch(setUpdateSearcher(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchUpdateUniversityFailure(error.message));
        }
    };
};
